import { render, staticRenderFns } from "./Linebreak.vue?vue&type=template&id=189747f9"
import script from "./Linebreak.vue?vue&type=script&lang=ts"
export * from "./Linebreak.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports